import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FiltersContainer = styled.div`
  display: grid;
  /* auto-fit + minmax deixa os filtros quebrarem em linhas quando falta largura;
     com repeat(8, 1fr) as colunas nao encolhem abaixo do conteudo (1fr == minmax(auto, 1fr))
     e os botoes do fim vazam a direita (ex: zoom 125%) */
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  -webkit-box-align: end;
  align-items: end;
  gap: 16px;
  height: 100%;

  > * {
    min-width: 0;
  }
`;
